import m from "moment";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./imageUploader.scss";

import { useDispatch, useSelector } from "react-redux";
import { allowedImagesExtensions } from "../../../helpers/enums";

import { client } from "../../../App";
import { SwitchUser } from "../../../helpers/helpers";
import { deleteImage, uploadImageToS3 } from "../../../reducers/auth";
import ArrowUp from "./Assets/icon-arrow-up.svg";

const ImageUploader = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const auth = useSelector((state: any) => state.auth);
  const profileUser = SwitchUser(auth);
  const hiddenFileInput = React.useRef<HTMLInputElement>(null);

  const [fileInfo, setFileInfo] = useState<[string, any] | []>([]);

  const [errors, setErrors] = useState({ hasError: false, error: "" });
  const profileImage = profileUser.profilePicture || "";
  const authErrors = profileUser.error || "";

  useEffect(() => {
    if (authErrors.length) {
      setErrors({ hasError: true, error: t(`common.${authErrors}`) });
    }

    return () => {};
  }, [authErrors, t]);

  const handleChange = (event: any) => {
    setErrors({ hasError: false, error: "" });
    const fileUploaded = event.target.files[0];
    if (fileUploaded) {
      const fileName = fileUploaded.name;
      const lastStr = fileName.lastIndexOf(".");
      const extension = fileName.substring(lastStr + 1);

      const timestamp = m().unix();
      const fileSize = fileUploaded.size / 1024 / 1024;
      const fileNameUpload = `profilePicture-${timestamp}.${extension}`;

      console.log("EXT", extension);
      console.log("RESULT", allowedImagesExtensions.indexOf(extension));

      if (allowedImagesExtensions.indexOf(extension) === -1) {
        setErrors({
          hasError: true,
          error: t("common.badExtension"),
        });
        return;
      }
      if (fileSize > 10) {
        setErrors({ hasError: true, error: t("common.fileSizeAllowed") });
        return;
      }
      if (!props.confirmUpload) {
        dispatch(uploadImageToS3(fileNameUpload, fileUploaded, client, null));
      } else {
        setFileInfo([fileNameUpload, fileUploaded]);
      }
    }
  };

  const handleDeleteImage = () => {
    dispatch(deleteImage(client));
    if (hiddenFileInput.current) {
      hiddenFileInput.current.value = "";
    }
  };

  const handleUpload = () => {
    hiddenFileInput?.current?.click();
  };

  const manualUpload = () => {
    if (fileInfo.length) {
      const [fileName, file] = fileInfo;
      dispatch(uploadImageToS3(fileName, file, client, props.setPopup));
      return;
    }
    setErrors({ hasError: true, error: t("common.badExtension") });
  };
  return (
    <>
      <div
        className={
          props.isFromModal
            ? "image-uploader isFromModal"
            : "container image-uploader"
        }
        data-testid="ImageUploader"
      >
        <div
          className={props.isFromModal ? "" : "col-sm-12 col-md-10 offset-md-1"}
        >
          <div
            className={
              props.isFromModal
                ? "profile-image-text-container"
                : "profile-image-text-container row"
            }
          >
            <h2 className="title-profile-image headline-bold-fs4">
              {props.isFromModal
                ? "Carica un'immagine"
                : t("user-profile.titleProfileImage")}
            </h2>
            {!props.isFromModal ? (
              <p className="add-profile-image paragraph-large-fs7">
                {t("common.selectProfilePicture")}
              </p>
            ) : null}
          </div>
          <div
            className={
              props.isFromModal ? "content-container" : "content-container row"
            }
          >
            {profileImage.length && !fileInfo.length ? (
              <>
                <div className="image-container">
                  <img alt="" src={profileImage} />
                </div>
                {props.confirmUpload && fileInfo.length > 0 ? (
                  <div className="file-loaded">
                    <p>{t("common.fileCaricato")}</p>
                  </div>
                ) : null}
                {/*(
                  <div onClick={handleDeleteImage} className="remove-image">
                    <p>{t("common.removeImage")}</p>
                  </div>
                )}*/}
              </>
            ) : (
              <div className="d-flex no-image">
                <div className="image-placeholder">
                  <i
                    className="gc-icon-functional-profile-2-col"
                    aria-hidden="true"
                  >
                    <span className="path1" />
                  </i>
                </div>
                {props.confirmUpload && fileInfo.length > 0 ? (
                  <div className="file-loaded">
                    <p>{t("common.fileCaricato")}</p>
                  </div>
                ) : (
                  <div className="description">
                    <p>{t("common.noFile")}</p>
                  </div>
                )}
              </div>
            )}

            <div className="gcap-cta">
              <input
                data-testid="inputImageUpload"
                type="file"
                ref={hiddenFileInput}
                onChange={handleChange}
                style={{ display: "none" }}
              />
              <button onClick={handleUpload} className="choose-file-container">
                <span className="choose-file-text paragraph-main-fs8">
                  {t("common.chooseFile.lowercase")}
                </span>
                <img src={ArrowUp} alt="" />
              </button>
            </div>
          </div>
          {errors.hasError ? (
            <div className="d-flex justify-content-start errors">
              <i
                className="gc-icon-functional-attention-1-col"
                aria-hidden="true"
              />
              <p>{errors.error}</p>
            </div>
          ) : null}
          {props.confirmUpload && (
            <div className="d-flex confirm-save">
              <button onClick={manualUpload} className="btn btn-primary">
                {t("common.updateBtn")}
              </button>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ImageUploader;
